import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog, MatDatepickerInputEvent, MatTabChangeEvent } from '@angular/material';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { TravelService } from '../../services/travel/travel.service';
import { Travel } from 'src/app/models/travel';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/modules/login/services/auth/auth.service';
import { TravelSummaryAddComponent } from '../travel-summary-add/travel-summary-add.component';
import { TravelSummaryViewComponent } from '../travel-summary-view/travel-summary-view.component';
import { DatePipe } from '@angular/common';
import { TravelAuthorizationCancelComponent } from '../travel-authorization-cancel/travel-authorization-cancel.component';
import { travelAuthorUrl, travelItineraryUrl, BOOKINGMETHOD, BOOKINGTYPE, travelRequestUrl, PURPOSE } from 'src/app/modules/shared/common/api';
import { TravelItineraryViewComponent } from 'src/app/modules/shared/components/travel-itinerary-view/travel-itinerary-view.component';
import { FunctionsService } from 'src/app/modules/shared/services/functions.service';
import * as moment from 'moment';
import {map, startWith} from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AddressService } from 'src/app/modules/shared/services/address/address.service';
import { LookUpLocationComponent } from 'src/app/modules/shared/components/look-up-location/look-up-location.component';
import { NotifyboxComponent } from 'src/app/modules/shared/components/notifybox/notifybox.component';
import { ConfirmationMessageComponent } from 'src/app/modules/shared/components/confirmation-message/confirmation-message.component';

export interface City {
  name: string;
}


@Component({
  selector: 'app-travel-authorization-view',
  templateUrl: './travel-authorization-view.component.html',
  styleUrls: ['./travel-authorization-view.component.scss']
})
export class TravelAuthorizationViewComponent implements OnInit {

  formGroup: FormGroup;
  objectKeys = Object.keys;

  detail: Travel;
  selectedIndex = 0;
  asn:boolean = false;
  isEmptyDate:boolean = false;
  loading:boolean = false;
  isCurrency:boolean = false;
  isCharged:boolean = false;
  isCreate:boolean = false;
  isOther:boolean = false;
  isFromSearchDate:boolean = true;
  show:boolean = false;
  displayForm:boolean = false;
  canDelete:boolean = false;
  active:boolean = false;
  travel: Travel;
  _user: User;
  successMessage = '';
  labelName = "";
  isError = false;
  msgErr = "";
  draftmsg = "";
  itineraryId:any;
  qty = {};
  pipe = new DatePipe('en-US');

  option =  {
    btnOk:'Yes',
    btnCancel: 'Cancel',
  }

  fDate:any;
  tDate:any;
  currDate: any;
  forDate: any;
  toDate: any;
  dialogConfig:any;
  expensesList:any;
  departmentList = JSON.parse(localStorage.getItem('department'));
  positionList = JSON.parse(localStorage.getItem('position'));
  itineraries:any;
  mealTotal = 0;
  perDiemTotal=0;
  partialExpense = 0;
  index = 0;
  total = 0;
  savemode = 0;
  tempSelectedIndex=0;
  countdays=[];
  objArray = [];
  miscItem = [];
  summarymsg = '';
  arr: FormArray;

  employeeDetail = [];

  statusOption={
    3 : 'Approved',
    4 : 'Rejected',
    5 : 'Cancelled'
  }

  travelOption = ["Individual","Group"];
  purposeOption = PURPOSE;
  natureOption = ["Inbound","Outbound"];
  bookedMethod = BOOKINGMETHOD;
  bookedOption = BOOKINGTYPE;
  currencyOption = [
    {id:1,name:"PHP"},
    {id:2,name:"USD"},
    {id:3,name:"Others"}
  ];
  chargeOption = [
    {id:1,name:"Rose Pharmacy"},
    {id:2,name:"DF"},
    {id:3,name:"Supplier"},
    {id:4,name:"RRHI"},
    {id:5,name:"Southstar Drug"}
  ];

  billOption = ["Store Support Center","Requestor"];

  options: City[] = [
    {name: 'Manila'},
    {name: 'Cebu'},
    {name: 'Davao'}
  ];
  filteredOptions: Observable<string[]>;
  filterCity = JSON.parse(localStorage.getItem('citylist'));
  cityLabel:any;

  constructor(
    public dialogRef: MatDialogRef<TravelAuthorizationViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public travelService: TravelService,
    public authService: AuthService,
    public functionService:FunctionsService,
    private formBuilder: FormBuilder,
    public address: AddressService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.detail = this.data.res;
    this._user = new User(this.authService.getAuthUser());
    this.formGroup = this.formBuilder.group({
      date_submitted:['',null],
      itinerary_date: ['',null],
      travel_authorization_no: ['',null],
      travel_authorization_id: ['',null],
      travel_request_id: ['',null],
      complete_name:['',null],
      employee_id_no: ['',null],
      position: ['',null],
      area_covered: ['',null],
      payroll_acct_no: ['',null],
      copy_date: ['',null],
      nature: ['',null],
      representation:['',null],
      miscellaneous:['',null],
      amount: ['',null],
      booked_by: ['',null],
      booking_method: ['',null],
      bill_to: ['',null],
      is_draft: ['',null],
      accommodation_cost: ['',null],
      travel_itinerary_details:['',null],
      is_lunch:['',null],
      is_dinner:['',null],
      is_breakfast: ['',null],
      meal:['',null],
      per_diem:['',null],
      others:['',null],
      itinerary_miscellaneous: this.formBuilder.array([]),
      push_back_id:['',null],
      travel_request_type:['',null],
      employee_name:['',null],
      employee_id: ['',null],
      level:['',null],
      department: ['',null],
      area_assigned:['',null],
      travel_type: ['',null],
      purpose: ['',null],
      location: ['',null],
      booking_type: ['',null],
      booking_type_itinerary: ['',null],
      inclusive_date_from: ['',null],
      inclusive_date_to: ['',null],
      currency: ['',null],
      currency_category: ['',null],
      charged_to_category: ['',null],
      charged_to: ['',null],
      travel_itineraries:['',null],
    });
    this.travel = new Travel(this.data.res);
    this.arr = this.formGroup.get('itinerary_miscellaneous') as FormArray;

    if (!this.data.res.travel_itineraries[0]) {
      this.getOthers();
    }

    this.data.display = true;
    this.data.disable = true;
    this.travel.booking_details_list = this.data.res.travel_booking_details;
    this.travel.itinerary_date = this.data.res.itinerary_date;
    this.formGroup.controls['area_covered'].setValue(this.data.res.area_covered);
    this.formGroup.controls['amount'].setValue(0);
    this.formGroup.controls['bill_to'].setValue(this.data.res.travel_summary.bill_to);
    this.formGroup.controls['position'].setValue(this.data.res.position);
    this.formGroup.controls['department'].setValue(this.data.res.department);
    this.formGroup.controls['payroll_acct_no'].setValue(this.data.res.payroll_acct_no);
    this.formGroup.controls['booked_by'].setValue(this.data.res.travel_summary.booked_by);
    this.formGroup.controls['charged_to'].setValue(this.data.res.travel_summary.charged_to);
    this.formGroup.controls['currency'].setValue(this.data.res.travel_summary.currency_category_value);
    this.formGroup.controls['currency_category'].setValue(this.data.res.travel_summary.currency_category);
    this.formGroup.controls['charged_to_category'].setValue(this.data.res.travel_summary.charged_to_category);
    this.formGroup.controls['inclusive_date_from'].setValue(this.data.res.travel_summary.inclusive_date_from);
    this.formGroup.controls['inclusive_date_to'].setValue(this.data.res.travel_summary.inclusive_date_to);
    this.formGroup.controls['location'].setValue(this.data.res.travel_summary.location);
    this.formGroup.controls['nature'].setValue(this.data.res.travel_summary.nature);
    this.formGroup.controls['others'].setValue(this.data.res.travel_summary.others);
    this.formGroup.controls['travel_request_id'].setValue(this.travel.id);
    this.formGroup.controls['itinerary_date'].setValue(this.data.res.itinerary_date);

    // Version 1.5
    this.formGroup.controls['travel_request_type'].setValue(this.data.res.travel_request_type);
    this.formGroup.controls['employee_name'].setValue(this.data.res.employee_name);
    this.formGroup.controls['employee_id'].setValue(this.data.res.employee_id);
    this.formGroup.controls['level'].setValue(this.data.res.level);
    this.formGroup.controls['area_assigned'].setValue(this.data.res.area_assigned);
    
    this.formGroup.controls['travel_type'].setValue(this.data.res.travel_summary.travel_type);
    this.formGroup.controls['booking_type'].setValue(this.data.res.travel_summary.booking_type);

    this.employeeDetail['level'] = this.data.res.level;
    this.employeeDetail['department'] = this.data.res.department;
    this.employeeDetail['area_assigned'] = this.data.res.area_assigned;

    let purposeOption = this.data.res.travel_summary.purpose.split("|");

    this.formGroup.controls['purpose'].setValue(purposeOption[0]);
    this.data.isOther = false;
    if (purposeOption[0] == "OTHERS") {
      this.isOther = true;
      this.data.isOther = true;
     // this.formGroup.controls['others'].setValue(this.data.res.travel_summary.others);
    }
    if (this.data.res.status_id != 6) {
      this.formGroup.controls['push_back_id'].disable();
    }
 
    //disable cost 
    this.formGroup.controls['accommodation_cost'].disable();

    //itineraries 
    if (this.data.res.travel_itineraries[0]) {
      this.formGroup.controls['travel_itineraries'].setValue(this.data.res.travel_itineraries);
      this.itineraryId = this.data.res.travel_itineraries[0].id;
      this.formGroup.controls['itinerary_date'].setValue(this.data.res.travel_itineraries[0].itinerary_date);
      this.formGroup.controls['accommodation_cost'].setValue(this.data.res.travel_itineraries[0].accommodation_cost);
      this.formGroup.controls['booked_by'].setValue(this.data.res.travel_itineraries[0].booked_by);
      this.formGroup.controls['bill_to'].setValue(this.data.res.travel_itineraries[0].bill_to);
      this.formGroup.controls['representation'].setValue(this.data.res.travel_itineraries[0].representation);
      this.formGroup.controls['miscellaneous'].setValue(this.data.res.travel_itineraries[0].miscellaneous);
      this.formGroup.controls['per_diem'].setValue(this.data.res.travel_itineraries[0].per_diem);
      this.formGroup.controls['is_lunch'].setValue(this.data.res.travel_itineraries[0].is_lunch);
      this.formGroup.controls['is_breakfast'].setValue(this.data.res.travel_itineraries[0].is_breakfast);
      this.formGroup.controls['is_dinner'].setValue(this.data.res.travel_itineraries[0].is_dinner);
      this.formGroup.controls['meal'].setValue(this.data.res.travel_itineraries[0].meal);

      this.formGroup.controls['booking_type_itinerary'].setValue(this.data.res.travel_itineraries[0].booking_type);
      this.formGroup.controls['booking_method'].setValue(this.data.res.travel_itineraries[0].booking_method);
 
      if ( this.data.res.travel_itineraries[0].itinerary_miscellaneous) {
        this.searchDate();
      }

      this.mealTotal = this.data.res.travel_itineraries[0].meal;
      this.itineraries = this.data.res.travel_itineraries[0].travel_itinerary_details;
      this.travel.summary_list = this.data.res.travel_itineraries[0].travel_itinerary_details;
      this.formGroup.controls['travel_itinerary_details'].setValue(this.travel.summary_list);
      this.displayForm = true;
      this.partialExpense = this.data.res.travel_itineraries[0].total_expense;

    }

    this.fDate = this.data.res.travel_summary.inclusive_date_from;
    this.tDate = this.data.res.travel_summary.inclusive_date_to;
    this.forDate = this.data.res.travel_summary.inclusive_date_from;
    this.toDate = this.data.res.travel_summary.inclusive_date_to

    //this.expensesList = this.data.res.travel_itineraries;
    this.travel.formGroup = this.formGroup;
    this.expensesList  = this.functionService.loopRangeDate(
      [this.data.res.travel_summary.inclusive_date_from,this.data.res.travel_summary.inclusive_date_to],
      this.data.res.travel_itineraries
    );

    if (this.data.res.travel_summary.currency_category == 3) {
      this.isCurrency = true;
    }
    
    if (this.data.res.travel_summary.charged_to_category == 3) {
      this.isCharged = true;
    }

    this.labelName = this.statusOption[this.data.res.status_id];

    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.autoFocus = false;
    this.dialogConfig.position = {
      'top': '0',
      'right': '0',
    }
    this.dialogConfig.width = '800px';
    this.dialogConfig.height = '100%';
    this.dialogConfig.disableClose = true;
    this.dialogConfig.panelClass = 'mat-dialog';

    this.travel.disableForm();
    this.travel.itineraries = this.data.res.travel_itineraries;

    //accommodation logic
    this.formGroup.get('booking_type_itinerary').valueChanges.subscribe(value => {
      if (value.toLowerCase() == "office" && this.formGroup.get('booking_method').value.toLowerCase() == "book only") {
        this.formGroup.controls['accommodation_cost'].enable();
      } else if (value.toLowerCase() == "self" && this.formGroup.get('booking_method').value.toLowerCase() == "book and pay"){
        this.formGroup.controls['accommodation_cost'].enable();
      } else {
        if (this.formGroup.controls['accommodation_cost'].value == '' || this.formGroup.controls['accommodation_cost'].value != 0) {
          this.formGroup.controls['accommodation_cost'].setValue(0);
        }
        this.formGroup.controls['accommodation_cost'].disable();
      }
    });

    //accommodation logic
    this.formGroup.get('booking_method').valueChanges.subscribe(value => {
      if (value.toLowerCase() == "book only" && this.formGroup.get('booking_type_itinerary').value.toLowerCase() == "office") {
        this.formGroup.controls['accommodation_cost'].enable();
      } else if (value.toLowerCase() == "book and pay" && this.formGroup.get('booking_type_itinerary').value.toLowerCase() == "self"){
        this.formGroup.controls['accommodation_cost'].enable();
      } else {
        if (this.formGroup.controls['accommodation_cost'].value == '' || this.formGroup.controls['accommodation_cost'].value != 0) {
          this.formGroup.controls['accommodation_cost'].setValue(0);
        }
        this.formGroup.controls['accommodation_cost'].disable();
      }
    });

    this.filteredOptions = this.formGroup.get('location').valueChanges
    .pipe(
      startWith(''),
      map(val => this._filter(val)));

    if (this.travel.itineraries.length > 1) {
      this.isEmptyDate = true;
    } else {
      this.isEmptyDate = false;
    }
  }

  getOthers(){
      this.address.getMisc().subscribe(res => {
        this.miscItem = res;
        res.forEach(element => {
          this.objArray.push({
            name: element.name,
            miscellaneous_id: element.id,
            amount: '',
          });
          this.arr.push(this.formBuilder.group({
            name: [element.name,null],
            miscellaneous_id: [element.id,null],
            amount: ['',null],
          }));
        });
      });
      this.formGroup.controls['itinerary_miscellaneous'].patchValue(this.objArray);
  }

    /**
   * 1 = country
   * 2 = province
   * 3 =  city
   * 4 = barangay
   * @param i 
   */
  locationLookUp(i?:number,formInput?:string,mode?:string){
    this.dialogConfig.width = '605px';
    this.dialogConfig.data = {
        i,
        city: this.filterCity,
        barangay: null
    }
    let dialogRef = this.dialog.open(LookUpLocationComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.formGroup.controls[formInput].setValue(result.value);
      }
    });
  }

  searchCity(e) {
    let title =  e;
    if (title.length > 3) {
      this.address.getCityList(title).subscribe(res=>{
        this.filterCity = res;
      });
    }
  }

  /**
   * Check Date date
   * @param event 
   */
  searchDate(event?: MatDatepickerInputEvent<Date>){
    let valueDate = (event)? event.value : this.formGroup.controls['itinerary_date'].value;
    let itineraryDate = this.pipe.transform(valueDate, 'yyyy-MM-dd');
    this.travel.itinerary_date = itineraryDate;
    let id = this.data.res.id;
    this.travelService.url= travelItineraryUrl+'/search?request_id='+id+'&itinerary_date='+itineraryDate;
    this.travelService.getFilter().subscribe(res=>{
      if (res.id) {
        this.travel.itinerary_date = itineraryDate;
        this.travel.id =  res.travel_request_id;
        this.formGroup.controls['accommodation_cost'].setValue(res.accommodation_cost);
        this.formGroup.controls['booked_by'].setValue(res.booked_by);
        this.formGroup.controls['bill_to'].setValue(res.bill_to);
        
        this.formGroup.controls['booking_type_itinerary'].setValue(res.booking_type || '');
        this.formGroup.controls['booking_method'].setValue(res.booking_method || '');

        if (this.formGroup.get('booking_method').value.toLowerCase() == "book only" && this.formGroup.get('booking_type_itinerary').value.toLowerCase() == "office") {
          this.formGroup.controls['accommodation_cost'].enable();
          this.formGroup.controls['accommodation_cost'].setValue(res.accommodation_cost);
        } else if (this.formGroup.get('booking_method').value.toLowerCase() == "book and pay" && this.formGroup.get('booking_type_itinerary').value.toLowerCase() == "self"){
          this.formGroup.controls['accommodation_cost'].enable();
          this.formGroup.controls['accommodation_cost'].setValue(res.accommodation_cost);
        } else {
          if (this.formGroup.controls['accommodation_cost'].value == '') {
            this.formGroup.controls['accommodation_cost'].setValue(0);
          }
          this.formGroup.controls['accommodation_cost'].disable();
        }
        this.active = false;
        this.formGroup.controls['per_diem'].setValue(res.per_diem);
        this.formGroup.controls['representation'].setValue(res.representation);
        this.formGroup.controls['miscellaneous'].setValue(res.miscellaneous);
        
        this.formGroup.controls['meal'].setValue(res.meal);
        this.formGroup.controls['is_breakfast'].setValue(res.is_breakfast);
        this.formGroup.controls['is_dinner'].setValue(res.is_dinner);
        this.formGroup.controls['is_lunch'].setValue(res.is_lunch);
        this.formGroup.controls['itinerary_date'].setValue(itineraryDate);
        this.formGroup.controls['travel_itinerary_details'].setValue(res.travel_itinerary_details);
        this.refreshFormArray();

        if (res.itinerary_miscellaneous) {
          this.objArray = [];
          res.itinerary_miscellaneous.forEach((element,i) => {
            if (element.miscellaneous) {
              this.objArray.push({
                name: element.miscellaneous.name,
                miscellaneous_id: element.miscellaneous.id,
                amount: element.amount,
              });
              this.arr.push(this.formBuilder.group({
                name: [element.name,null],
                miscellaneous_id: [element.miscellaneous.id,null],
                amount: ['',null],
              })); 
            }
            // (<FormArray>this.formGroup.controls['itinerary_miscellaneous']).at(i).patchValue({
            //   name: element.name,
            //   miscellaneous_id: element.miscellaneous_id,
            //   amount: element.amount,
            // });
          });
          this.formGroup.controls['itinerary_miscellaneous'].patchValue(this.objArray);
        }

        this.travel.summary_list = res.travel_itinerary_details;
        this.itineraries = res.travel_itinerary_details;
        //this.mealTotal = res.meal;//disabled because it overrides meal total
        this.travel.getTotal();
        this.partialExpense = res.total_expense;
        if (this.travel.itineraries.length >= 1) {
          this.isEmptyDate = true;
          this.countdays.push(1);
        }
        this.itineraryId = res.id;
        this.isEmptyDate = false;
        this.displayForm = true;
        this.canDelete = true;
        this.savemode = 0;
      } else {
        this.savemode = 1;
        this.active = false;
        this.isEmptyDate = false;
        this.displayForm = false;
        this.canDelete = false;
        this.itineraryId = 0;
        this.itineraries = [];
        this.mealTotal = 0;
        this.perDiemTotal = 0;
        this.travel.totalExpenses = 0;
        this.clear();
        this.travel.itinerary_date = itineraryDate;
        this.formGroup.controls['itinerary_date'].setValue(itineraryDate);
      }
    },(err => {

    }));
  }

  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    this.selectedIndex =  tabChangeEvent.index;
  }

  refreshFormArray() {
    while (this.arr.length !== 0) {
      this.arr.removeAt(0);
    }
  }

    /**
   * Save Itinerary
   */
  saveItinerary() {
    this.loading = true;
    this.formGroup.controls['itinerary_date'].setValue(this.pipe.transform(this.formGroup.controls['itinerary_date'].value, 'yyyy-MM-dd'));
    this.formGroup.controls['travel_itinerary_details'].setValue(this.travel.summary_list);
    this.active = true;
    if (this.savemode == 0) {
      this.travelService.updateItinerary(this.itineraryId,this.formGroup.getRawValue()).subscribe(res=>{
        this.loading = false;
        this.travel.itineraries = res['data'].data[0].travel_itineraries;
        this.displayForm = false
        this.countdays.push(1);

        // Display summary expenses
        this.expensesList  = this.functionService.loopRangeDate(
          [res['data'].data[0].travel_summary.inclusive_date_from,res['data'].data[0].travel_summary.inclusive_date_to],
           res['data'].data[0].travel_itineraries
        );

        if (this.pipe.transform(this.formGroup.controls['itinerary_date'].value, 'yyyy-MM-dd') == this.tDate) { 
          this.selectedIndex = 2;
        } else {
          let currentDate = this.incrementDates(this.pipe.transform(this.formGroup.controls['itinerary_date'].value, 'yyyy-MM-dd'));
          this.formGroup.controls['itinerary_date'].setValue(currentDate);
          this.searchDate();
        }
        this.travel.clearTotal();
        this.travel.getTotal();  
        this.loading = false;
      },(err =>{
        this.loading = false;
        this.active = false;
        this.travel.setErrors(err.error.errors);
        this.travel.triggerErrors(err.error.errors);
      }));
    } else {
      this.formGroup.controls['itinerary_date'].setValue(this.pipe.transform(this.formGroup.controls['itinerary_date'].value, 'yyyy-MM-dd'));
      this.formGroup.controls['travel_itinerary_details'].setValue(this.travel.summary_list);
      this.formGroup.controls['travel_request_id'].setValue(this.detail.id);
      this.travelService.storeIntinerary(this.formGroup.getRawValue()).subscribe(res=>{
        this.loading = false;
        this.travel.itineraries = res['data'].data[0].travel_itineraries;
        this.countdays.push(1);
        this.travel.summary_list = [];
        // Display Summary expenses
        this.expensesList  = this.functionService.loopRangeDate(
          [res['data'].data[0].travel_summary.inclusive_date_from,res['data'].data[0].travel_summary.inclusive_date_to],
           res['data'].data[0].travel_itineraries
        );

        
        if (this.pipe.transform(this.formGroup.controls['itinerary_date'].value, 'yyyy-MM-dd') == this.tDate) { 
          this.selectedIndex = 2;
        } else {
          let currentDate = this.incrementDates(this.pipe.transform(this.formGroup.controls['itinerary_date'].value, 'yyyy-MM-dd'));
          this.formGroup.controls['itinerary_date'].setValue(currentDate);
          this.searchDate();
        }

        this.travel.clearTotal();
        this.travel.getTotal();
        this.loading = false;
        this.isEmptyDate = false;
        this.isCreate = false;
        this.active = false;
      },(err =>{
        this.loading = false;
        this.active = false;
        this.travel.setErrors(err.error.errors);
        this.travel.triggerErrors(err.error.errors);
      }));
    }
    
  }

  populatePerDiem(){
    let lvl = this.formGroup.controls['level'].value

    if(lvl == "MANAGER1"){
      this.perDiemTotal = 1000
    }
    else if(lvl == "MANAGER"){
      this.perDiemTotal = 1000
    }
    else if(lvl == "SUPERVISORY"){
      this.perDiemTotal = 800
    }
    else if(lvl == "MANAGER2"){
      this.perDiemTotal = 1000
    }
    else if(lvl == "EXECOM"){
      this.perDiemTotal = 2500
    }
    else{
      this.perDiemTotal = 150
    }

    this.formGroup.controls['per_diem'].setValue(this.perDiemTotal)
  }

  clearPerDiem(){
    this.perDiemTotal = 0
    this.formGroup.controls['per_diem'].setValue(this.perDiemTotal)
  }

  //Disabled some lines in SearchDate() becuase it overrides the user's edited per diem and meal

  /**
   * Compute Meal Value Option
   * @param e 
   * @param i 
   */
  mealvalue(e,i) {
    let lvl = this.formGroup.controls['level'].value

    switch (i) {
      case 1:
        this.formGroup.controls['is_breakfast'].setValue((i == 1 && e.checked)? 1 : 0 );
        break;
      case 2:
        this.formGroup.controls['is_lunch'].setValue((i == 2  && e.checked)? 1 : 0 );
        break;
      case 3:
        this.formGroup.controls['is_dinner'].setValue((i == 3  && e.checked)? 1 : 0 );
      break;
      default:
        break;
    }

    if (e.checked) {
      if(lvl == "MANAGER"){
        this.mealTotal += 100;
      }
      else if(lvl == "MANAGER1"){
        this.mealTotal += 100;
      }
      else if(lvl == "MANAGER2"){
        this.mealTotal += 100;
      }
      else if(lvl == "EXECOM"){
        this.mealTotal += 150;
      }
      else{
        this.mealTotal += 50;
      }
  
    }
    else {
      if(lvl == "MANAGER"){
        this.mealTotal -= 100;
      }
      else if(lvl == "MANAGER1"){
        this.mealTotal -= 100;
      }
      else if(lvl == "MANAGER2"){
        this.mealTotal -= 100;
      }
      else if(lvl == "EXECOM"){
        this.mealTotal -= 150;
      }
      else{
        this.mealTotal -= 50;
      } 
    }
    this.formGroup.controls['meal'].setValue(this.mealTotal);
  }

  autoPopulateMeal(){
    let lvl = this.formGroup.controls['level'].value

    if(lvl == "MANAGER"){
      this.mealTotal += 300;
    }
    else if(lvl == "MANAGER1"){
      this.mealTotal += 300;
    }
    else if(lvl == "MANAGER2"){
      this.mealTotal += 300;
    }
    else if(lvl == "EXECOM"){
      this.mealTotal += 450;
    }
    else{
      this.mealTotal += 150;
    }
    this.formGroup.controls['meal'].setValue(this.mealTotal);
    this.formGroup.controls['is_breakfast'].setValue(1)
    this.formGroup.controls['is_lunch'].setValue(1)
    this.formGroup.controls['is_dinner'].setValue(1)
  }

  mealResetValues(){
    this.mealTotal = 0
    this.formGroup.controls['meal'].setValue(this.mealTotal)
    this.formGroup.controls['is_breakfast'].setValue('')
    this.formGroup.controls['is_lunch'].setValue('')
    this.formGroup.controls['is_dinner'].setValue('')
  }
  mealReset(){
    this.formGroup.controls['employee_name'].valueChanges.subscribe( value =>{ this.mealResetValues() })
    this.formGroup.controls['employee_id'].valueChanges.subscribe( value =>{ this.mealResetValues() })
  }

  closeOnClick() {
    this.dialogRef.close(true);
  }

 /**
  * Save as Draft data
  * @param bool true/false
  */
  saveAsDraft(bool:boolean) {
    this.loading = true;
    this.formGroup.controls['is_draft'].setValue(bool);
    this.formGroup.controls['inclusive_date_to'].setValue(this.pipe.transform(this.formGroup.controls['inclusive_date_to'].value, 'yyyy-MM-dd'));
    this.formGroup.controls['inclusive_date_from'].setValue(this.pipe.transform(this.formGroup.controls['inclusive_date_from'].value, 'yyyy-MM-dd'));

    this.travelService.updateRequestInfo(this.formGroup.controls['travel_request_id'].value,this.formGroup.getRawValue()).subscribe(res=>{
      
      this.dialog.open(NotifyboxComponent, {
        disableClose:true,
        data: {
          reload:false,
          label:'Ok',
          message: res['message']
        }
      });
      this.loading = false;
      this.closeOnClick();
    },(err =>{
      this.loading = false;
      this.travel.setErrors(err.error.errors);
      this.travel.triggerErrors(err.error.errors);
      this.dialog.open(NotifyboxComponent, {
        disableClose:true,
        data: {
          reload:false,
          label:'Ok',
          isclose:true,
          message: err.error.errors.inclusive_date_from[0]
        }
      }).afterClosed().subscribe(result => {
        if (result) {
          // this.dialogRef.close(this.formGroup.value);
        }
      });
    }));
  }

  /**
   * Display Itinerary
   */
  display(){
    this.loading = true;
    this.formGroup.controls['accommodation_cost'].setValue(0);
    let id = this.formGroup.controls['travel_request_id'].value;
    this.travel.resetErrors();
    let travel_itineraries = this.formGroup.controls['travel_itineraries'].value;
    let itinerary_date = this.pipe.transform(this.formGroup.controls['itinerary_date'].value, 'yyyy-MM-dd');
    this.travelService.url= travelItineraryUrl+'/validate?travel_request_id='+id+'&itinerary_date='+itinerary_date;

    this.formGroup.controls['booking_type_itinerary'].setValue('');
    this.formGroup.controls['booking_method'].setValue('');
    //this.formGroup.controls['per_diem'].setValue('');
    //this.formGroup.controls['meal'].setValue('');
    this.formGroup.controls['is_breakfast'].setValue('');
    this.formGroup.controls['is_dinner'].setValue('');
    this.formGroup.controls['is_lunch'].setValue('');

    this.travelService.getFilter().subscribe(res=>{

      if (res) {
        this.loading = false;
        this.isCreate = true;
        this.displayForm = true;
        this.travel.summary_list = [];
        if (this.countdays.length >= 1 || (this.travel.itineraries.length > 1)) {
          this.isEmptyDate = true;
        } else {
          this.isEmptyDate = false;
        }
      }  
    },(err => {
      if (err.status == 400) {
        err.error.errors.itinerary[0] = '';
      }
      this.travel.setErrors(err.error.errors);
      this.travel.triggerErrors(err.error.errors);
      this.loading = false;
    }));
  }

  /**
   * Save Header Info
   */
  saveInfo(){
    
    if (!this.show) {
      this.selectedIndex = 1;
      return true;
    }

    this.loading = true;
    this.successMessage = '';
    let currency = '';
    let charged = '';

    if (this.data.res.status_id == 6) {
      this.formGroup.controls['push_back_id'].enable();
      this.formGroup.controls['push_back_id'].setValue(6);
    }

    let location = this._filter(this.formGroup.controls['location'].value);
   
    if (location[0] && (this.formGroup.controls['location'].value.length != location[0]['title'].length)) {
      // this.formGroup.controls['location'].setValue('');
    } else if(location.length == 0) {
      // this.formGroup.controls['location'].setValue('');
    } 

    if (this.formGroup.controls['currency_category'].value != 3 && this.formGroup.controls['currency_category'].value != '') {
      currency = this.currencyOption[this.formGroup.controls['currency_category'].value-1].name ;
    } else{
      currency = this.formGroup.controls['currency'].value;
    }

    if (this.formGroup.controls['charged_to_category'].value != 3 && this.formGroup.controls['charged_to_category'].value != '') {
      charged = this.chargeOption[this.formGroup.controls['charged_to_category'].value-1].name;
    } else {
      charged = this.formGroup.controls['charged_to'].value;
    }

    let purpose = (this.formGroup.controls['others'].value == '')? this.formGroup.controls['purpose'].value : this.formGroup.controls['purpose'].value + '|' + this.formGroup.controls['others'].value ;
    if (this.formGroup.controls['others'].value == '') {
      this.formGroup.controls['purpose'].setValue(purpose);
    } 
    this.formGroup.controls['currency'].setValue(currency);
    this.formGroup.controls['charged_to'].setValue(charged);
    this.formGroup.controls['is_draft'].setValue(true);
    this.formGroup.controls['inclusive_date_from'].setValue(this.pipe.transform(this.formGroup.controls['inclusive_date_from'].value, 'yyyy-MM-dd'));
    this.formGroup.controls['inclusive_date_to'].setValue(this.pipe.transform(this.formGroup.controls['inclusive_date_to'].value, 'yyyy-MM-dd'));
    this.forDate = this.pipe.transform(this.formGroup.controls['inclusive_date_from'].value, 'yyyy-MM-dd');
    this.toDate = this.pipe.transform(this.formGroup.controls['inclusive_date_to'].value, 'yyyy-MM-dd');

    if (this.formGroup.controls['travel_request_id'].value == '') {
      this.travelService.storeInfo(this.formGroup.getRawValue()).subscribe(res=>{
        
        this.loading = false;
        this.formGroup.controls['travel_request_id'].setValue(res['data'].data[0].id);
        this.selectedIndex=1;
      },(err =>{
        this.loading = false;
        this.travel.setErrors(err.error.errors);
        this.travel.triggerErrors(err.error.errors);
      }));
    } else {
      this.travelService.updateRequestInfo(this.formGroup.controls['travel_request_id'].value,this.formGroup.getRawValue()).subscribe(res=>{
        this.loading = false;
        this.fDate =  this.forDate;
        this.tDate = this.toDate;
        let itineraryDate = this.pipe.transform(this.fDate, 'yyyy-MM-dd');
        this.formGroup.controls['itinerary_date'].setValue(itineraryDate);
        this.formGroup.controls['travel_request_id'].setValue(res['data'].data[0].id);
        this.searchDate();
        this.selectedIndex=1;
      },(err =>{
        this.loading = false;
        this.travel.setErrors(err.error.errors);
        this.travel.triggerErrors(err.error.errors);
      }));
    }

  }

  deleteItinerary() {
    let dialogRef = this.dialog.open(ConfirmationMessageComponent, {
      disableClose:true,
      data: {
        message: "Are you sure you want to delete this itinerary?"
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.delete();
      }
    });
    
  }

  delete() {
    this.loading = true;
    let travel_request_id =  this.formGroup.controls['travel_request_id'].value;
    this.clear();
    this.isError = false;
    this.formGroup.controls['travel_request_id'].setValue(travel_request_id);

    if (this.itineraryId) {
      this.loading = true;
      this.travel.clearTotal();
      this.travelService.deleteItinerary(this.itineraryId,this.travel.id).subscribe(res=>{

        this.travel.itineraries = res['data'].data[0].travel_itineraries;
        this.travel.totalExpenses = res['data'].data[0].travel_itinerary_total.grand_total;

        if (this.travel.itineraries && this.travel.itineraries.length >= 1) {
          this.travel.fromDatePicker = true;
        } else {
          this.travel.fromDatePicker = false;
        }
        this.travel.id = null;
        this.loading = false;
        if (res['data'].data[0].travel_itineraries.length == 0) {
          this.show = true;
        }
        this.dialog.open(NotifyboxComponent, {
          disableClose:true,
          data: {
            reload:false,
            label:'Ok',
            message: 'Travel Itinerary has been deleted.'
          }
        });
        if (this.countdays.length >= 1) {
          this.countdays.shift();
        }
        this.isError = false;
        this.msgErr = '';
      },(err => {
        this.loading = false;
        this.travel.id = null;
      }));
    } else {
      this.loading = false;
      this.dialog.open(NotifyboxComponent, {
        disableClose:true,
        data: {
          reload:false,
          label:'Ok',
          message: 'The itinerary has been deleted.'
        }
      });
    }
    
    this.travel.resetErrors();
    this.travel.totalExpenses = 0;
    this.travel.summary_list = [];
    this.displayForm = false;
    this.isEmptyDate = false;
    this.isCreate = false;
  }

  closeMsg() {
    this.isError = false;
    this.msgErr = '';
  }

  /**
   * Copy date from prevoius
   */
  copyDate() {
    let previous_date = this.fDate;

    for(let i=0;i < this.travel.itineraries.length;i++) {
      if (moment(this.travel.itineraries[i].itinerary_date) < moment(this.travel.itinerary_date)) {
        previous_date = this.travel.itineraries[i].itinerary_date;
        for(let c=0;c < this.travel.itineraries.length;c++) {
          if (moment(previous_date) > moment(this.travel.itineraries[c].itinerary_date) &&
          moment(this.travel.itinerary_date) < moment(this.travel.itineraries[c].itinerary_date)) {
            previous_date = this.travel.itineraries[c].itinerary_date;
            break;
          }
        }
      }
    }

    this.travel.resetErrors();
    let id = this.detail.id;
    this.travelService.url= travelRequestUrl+'/copy?request_id='+id+'&date='+previous_date;
    this.travelService.getFilter().subscribe(res=>{

      this.formGroup.controls['accommodation_cost'].setValue(res.travel_itinerary_first.accommodation_cost);
      this.formGroup.controls['booked_by'].setValue(res.travel_itinerary_first.booked_by);
      this.formGroup.controls['bill_to'].setValue(res.travel_itinerary_first.bill_to);
      this.formGroup.controls['per_diem'].setValue(res.travel_itinerary_first.per_diem);
      this.formGroup.controls['representation'].setValue(res.travel_itinerary_first.representation);
      this.formGroup.controls['miscellaneous'].setValue(res.travel_itinerary_first.miscellaneous);
      this.mealTotal = res.travel_itinerary_first.meal;
      this.formGroup.controls['meal'].setValue(res.travel_itinerary_first.meal);
      this.formGroup.controls['is_breakfast'].setValue(res.travel_itinerary_first.is_breakfast);
      this.formGroup.controls['is_dinner'].setValue(res.travel_itinerary_first.is_dinner);
      this.formGroup.controls['is_lunch'].setValue(res.travel_itinerary_first.is_lunch);
      this.travel.summary_list = res.travel_itinerary_first.travel_itinerary_details;

      this.formGroup.controls['booking_type_itinerary'].setValue(res.travel_itinerary_first.booking_type || '');
      this.formGroup.controls['booking_method'].setValue(res.travel_itinerary_first.booking_method || '');

      //disable cost
      if (res.travel_itinerary_first.booking_type == "Office" && res.travel_itinerary_first.booking_method == "Book Only") {
        this.formGroup.controls['accommodation_cost'].enable();
        this.formGroup.controls['accommodation_cost'].setValue(res.travel_itinerary_first.accommodation_cost);
      } else if (res.travel_itinerary_first.booking_type == "Self" && res.travel_itinerary_first.booking_method == "Book and Pay"){
        this.formGroup.controls['accommodation_cost'].enable();
        this.formGroup.controls['accommodation_cost'].setValue(res.travel_itinerary_first.accommodation_cost);
      } else {
        if (this.formGroup.controls['accommodation_cost'].value == '' || this.formGroup.controls['accommodation_cost'].value != 0) {
          this.formGroup.controls['accommodation_cost'].setValue(0);
        }
        this.formGroup.controls['accommodation_cost'].disable();
      }

      if (res.travel_itinerary_first) {
        res.travel_itinerary_first.itinerary_miscellaneous.forEach((element,i) => {
          (<FormArray>this.formGroup.controls['itinerary_miscellaneous']).at(i).patchValue({
            name: element.name,
            miscellaneous_id: element.miscellaneous_id,
            amount: element.amount,
          });
        });
      }
      this.itineraries = res.travel_itinerary_first.travel_itinerary_details;
      this.itineraryId = 0;
    },(err => {
      console.log(err);
    }));
  }

   /**
   * Delete summary list
   * @param i = index in the list
   */
  deleteSummary(i) {
    let dialogRef = this.dialog.open(ConfirmationMessageComponent, {
      disableClose:true,
      data: {
        message: "Are you sure you want to delete this itinerary?"
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteSummaryConfirm();
      }
    });
    this.index = i;
  }

  deleteSummaryConfirm() {
    this.travel.summary_list.splice(this.index,1);

    this.summarymsg = "";
    this.dialog.open(NotifyboxComponent, {
      disableClose:true,
      data: {
        reload:false,
        label:'Ok',
        message: 'The Itinerary has been deleted.'
      }
    });
  }

  closeSummary() {
    this.summarymsg = "";
    this.index = 0;
  }

  keypressValidateNumber(e,max) {
    const pattern = new RegExp(/^\d*\.?\d{0,2}$/g); // '\d'
     return pattern.test(e.key);
  }

  /**
   * Number validation on input fields
   */  
  keypressValidateNumberDecimal(e) {
    const pattern = new RegExp(/^\d*\.?\d{0,2}$/g);
    const rgx = /^[0-9]*\.?[0-9]*$/;
    if ((e.key == '.' && e.target.value.includes('.')) || !pattern.test(e.key)) {
      return false;
    }
    return (e.target.value.match(rgx)) ? true : false;
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
        name: ['',null],
        miscellaneous_id: ['',null],
        amount: ['',null],
    });
  }

  /**
   * Cancel Travel Authorization
   */
  cancelTa(){
    this.dialogConfig.width = '800px';
    this.dialogConfig.data = {
      id: this.data.res.id
    }
    let dialogRef = this.dialog.open(TravelAuthorizationCancelComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.travel.setSummaryList(result);
        this.travel.status_id = result.status_id
        this.dialogRef.close(true);
      }
    });
  }

  /**
   *  Add Summary Modal Component
   */
  createSummary(){
    this.travel._errors = {};
    this.dialogConfig.width = '100vw';
    this.dialogConfig.data = {
      mode: 0,
      travel: this.travel
    }
    let dialogRef = this.dialog.open(TravelSummaryAddComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result != '') {
        this.travel.formGroup = this.formGroup;
        this.travel._errors = {};
        this.itineraries = this.travel.summary_list;
      }
    });
  }

  /**
   * Delete Travel Authorization Data
   */
  deleteAsDraft() {
    //this.draftmsg = "Are you sure you want to delete this draft?";
    let dialogRef = this.dialog.open(ConfirmationMessageComponent, {
      disableClose:true,
      data: {
        message: "Are you sure you want to delete this draft?"
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteDraft();
      }
    });
    
  }

  deleteDraft() {
    this.loading = true;
    let data = {
      status: 'Delete as Draft',

    }
    this.travelService.updateStatus(this.data.res.id,data).subscribe(res=>{
      
      this.draftmsg = "";
      this.dialog.open(NotifyboxComponent, {
        disableClose:true,
        data: {
          reload:false,
          label:'Ok',
          isclose:true,
          message: res['message']
        }
      }).afterClosed().subscribe(result => {
        if (result) {
          this.dialogRef.close(true);
        }
      });
    },(err =>{
      this.loading = false;
      this.travel.setErrors(err.error.errors);
      this.travel.triggerErrors(err.error.errors);
    }));
  }

  closeDraft() {
    this.draftmsg = "";
  }

  edit(){
    this.show = true;
    if (this.selectedIndex != 0) {
      this.selectedIndex = 2;
    }
    this.data.disable = false;
    this.travel.enableForm();

    if (this.travel.itineraries && this.travel.itineraries.length > 1) {
      // this.formGroup.controls['inclusive_date_from'].disable();
      // this.formGroup.controls['inclusive_date_to'].disable();
    } else {
      this.formGroup.controls['inclusive_date_from'].enable();
      this.formGroup.controls['inclusive_date_to'].enable(); 
    }
    if (this.travel.itineraries.length == 0 ) {
      this.travel.enableForm();
    }
  }

  /**
   * Manual change tab
   * @param e tab-index
   */
  next(e){
    this.selectedIndex=e;
  }

  back(e){
    this.travel._errors = {};
    this.travel.getTotal();
    if (this.travel.itineraries.length == 0 && this.show) {
      this.travel.enableForm();
      this.formGroup.controls['itinerary_date'].reset();
    } else {
      this.formGroup.controls['itinerary_date'].setValue(this.fDate);
      this.searchDate();
      // this.formGroup.controls['inclusive_date_from'].disable();
      // this.formGroup.controls['inclusive_date_to'].disable();
    }

    if (this.travel.itineraries && this.travel.itineraries.length >= 1) {
      this.travel.fromDatePicker = true;
    } else {
      this.travel.fromDatePicker = false;
    }

    this.isCreate = false;
    this.displayForm = false;
    this.travel.summary_list = [];
 
    this.selectedIndex=this.selectedIndex-1;
  }

  onChangeStartDate(e) {
    this.fDate = e.value;
  }

  onChangeEndDate(e) {
    this.tDate = e.value;
  }

  /**
   * Summary add Detail
   * mode temporay data
   * @param res 
   */
  editSummary(res,i) {
    this.dialogConfig.width = '100vw';
    this.dialogConfig.data = {
      res,
      list:this.itineraries,
      travel: this.travel,
      mode: 0,
      index:i,
      is_draft: true
    }

    let dialogRef = this.dialog.open(TravelSummaryViewComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result != '') {
        this.travel.formGroup = this.formGroup;
        this.itineraries = result;
      }
    });
  }


  /**
   * View itinerary Details Modal
   * @param res 
   */
  viewItinerary(res,i) {
    this.dialogConfig.width = '100vw';
    this.dialogConfig.data = {
      res,
      list:this.travel.booking_details_list,
      mode: 1,
      displayEdit: this.show,
      auth_id: this.data.res.travel_summary.travel_request_id,
      book_id: res.id,
      is_draft: (this.data.res.status_id == 0)? true : false
    }
    let dialogRef = this.dialog.open(TravelItineraryViewComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.travel.totalPortFee = 0;
        this.travel.totalLodging = 0;
        this.travel.totalDiem = 0;
        this.travel.totalMeal = 0;
        this.travel.totalRepre = 0;
        this.travel.totalMisc = 0;
        this.travel.totalExpenses = 0;
        this.travel.totalTranspo = 0;
        this.expensesList[i] = result;
        this.travel.itineraries[i] = result;
        this.travel.getTotal();
      }
    });
  }

  /**
   * Display Currency option
   * @param e = 3 get value for other currency
   */
  displayCurrency(e) {
    this.isCurrency = false;
    if (this.data.res.travel_summary.currency_category == 3) {
      this.formGroup.controls['currency'].setValue('');
      this.isCurrency = true;
    }
    this.formGroup.get('currency_category').valueChanges.subscribe(value => { 
      this.isCurrency = false;
      if (value == 3) {
        this.formGroup.controls['currency'].setValue('');
        this.isCurrency = true;
      }
    })
  }
  

  /**
   * Display other supplier
   * @param e  e = 3 get value for supplier
   */
  displayCharge(e) {
    this.isCharged = false;
    if (this.data.res.travel_summary.charged_to_category == 3) {
      this.isCharged = true;
    }
    this.formGroup.get('charged_to_category').valueChanges.subscribe(value => { 
      this.isCharged = false;
      if (value == 3) {
        this.isCharged = true;
      }
    })
  }

      /**
   * Display Purpose option
   * @param e = 3 get value for other currency
   */
  displayOthers(e) {
    this.isOther = false;
    this.formGroup.controls['others'].setValue('');
    this.formGroup.get('purpose').valueChanges.subscribe(value => {
      if (value  || value == "OTHERS") {
        this.isOther = true;
      } else {
        this.isOther = false;
      }
    })
  }

  /**
   * Remove in Object Array
   * @param index index key
   * @param data list
   */
  removeRow(index,data){
    data.splice(index, 1);
  }

  /**
   * Get Days between date
   */
  countDays() {
    var diff = Math.abs(this.fDate.getTime() - this.tDate.getTime());
    return Math.ceil(diff / (1000 * 3600 * 24)); 
  }

  /**
   * Increment Current Date as 1 day
   * @param dateString 
   */
  incrementDates(dateString) {
    var result = new Date(new Date(dateString).setDate(new Date(dateString).getDate() + 1));
    return result.toISOString().substr(0, 10);
  }

  clear() {
    this.formGroup.controls['itinerary_date'].setValue('');
    this.formGroup.controls['accommodation_cost'].setValue('');
    this.formGroup.controls['booked_by'].setValue('');
    this.formGroup.controls['bill_to'].setValue('');
    this.formGroup.controls['representation'].setValue('');
    this.formGroup.controls['miscellaneous'].setValue('');
    this.formGroup.controls['per_diem'].setValue('');
    this.formGroup.controls['meal'].setValue('');
    this.formGroup.controls['is_breakfast'].setValue('');
    this.formGroup.controls['is_lunch'].setValue('');
    this.formGroup.controls['is_dinner'].setValue('');
    this.mealTotal = 0;
    this.perDiemTotal = 0;
    this.partialExpense = 0;

    this.formGroup.controls['booking_type_itinerary'].setValue('');
    this.formGroup.controls['booking_method'].setValue('');

    this.refreshFormArray();
    this.getOthers();
  }

  displayFn(city: City) {
    if (city) { return city.name; }
  }

  private _filter(name: string): string[] {
    const filterValue = name.toLowerCase();
    return this.filterCity.filter(option => option.title.toLowerCase().includes(filterValue));
  }


} 